import { useState } from 'react';
import { forgotPassword } from '../../services/authApi';
import { useSnackbar } from '../../contexts/SnackbarProvider';
import { SnackbarType } from '../../components/Snackbar/types';
import { UseForgotPasswordReturn } from './types';

export const useForgotPassword = (): UseForgotPasswordReturn => {
  const [email, setEmail] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const showSnackbar = useSnackbar();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await forgotPassword(email);
      setIsSubmitted(true);
    } catch (err) {
      showSnackbar('リクエストに失敗しました。しばらく待ってから再試行してください。', SnackbarType.ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    email,
    setEmail,
    isLoading,
    isSubmitted,
    handleSubmit,
  };
};